import React, { createContext, useContext, useState, ReactNode } from "react";

type MerchantContextType = {
  clearData: boolean;
  triggerClearData: () => void;
  isAddingNewMerchant: boolean;
  setIsAddingNewMerchant: (value: boolean) => void;
  selectedCountry: string;
  setSelectedCountry: (value: string) => void;
};

const MerchantContext = createContext<MerchantContextType | undefined>(undefined);

export const useMerchantContext = () => {
  const context = useContext(MerchantContext);
  if (context === undefined) {
    throw new Error("useMerchantContext must be used within a MerchantProvider");
  }
  return context;
};

type MerchantProviderProps = {
  children: ReactNode;
};

export const MerchantProvider = ({ children }: MerchantProviderProps) => {
  const [clearData, setClearData] = useState(false);
  const [isAddingNewMerchant, setIsAddingNewMerchant] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<string>("US");

  const triggerClearData = () => {
    setClearData(true);
    setTimeout(() => setClearData(false), 100);
  };

  return (
    <MerchantContext.Provider
      value={{ clearData, triggerClearData, isAddingNewMerchant, setIsAddingNewMerchant, selectedCountry, setSelectedCountry }}
    >
      {children}
    </MerchantContext.Provider>
  );
};
